(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var state = new WeakMap();
  var scrollLock = { locked: false, scrollY: 0, body: {}, html: {} };

  function getScrollbarWidth() {
    return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  }

  function lockPageScroll() {
    if (scrollLock.locked) return;
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return;
    scrollLock.locked = true;
    scrollLock.scrollY = window.pageYOffset || html.scrollTop || body.scrollTop || 0;
    scrollLock.body = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight
    };
    scrollLock.html = { overflow: html.style.overflow, overscrollBehavior: html.style.overscrollBehavior };
    var scrollbarWidth = getScrollbarWidth();
    var currentPadding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
    html.classList.add('av-customize-dialog-open');
    body.classList.add('av-customize-dialog-open');
    html.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';
    body.style.position = 'fixed';
    body.style.top = '-' + scrollLock.scrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) body.style.paddingRight = (currentPadding + scrollbarWidth) + 'px';
  }

  function unlockPageScroll() {
    if (!scrollLock.locked) return;
    var body = document.body;
    var html = document.documentElement;
    var scrollY = scrollLock.scrollY || 0;
    if (html) {
      html.classList.remove('av-customize-dialog-open');
      html.style.overflow = scrollLock.html.overflow || '';
      html.style.overscrollBehavior = scrollLock.html.overscrollBehavior || '';
    }
    if (body) {
      body.classList.remove('av-customize-dialog-open');
      body.style.position = scrollLock.body.position || '';
      body.style.top = scrollLock.body.top || '';
      body.style.left = scrollLock.body.left || '';
      body.style.right = scrollLock.body.right || '';
      body.style.width = scrollLock.body.width || '';
      body.style.overflow = scrollLock.body.overflow || '';
      body.style.paddingRight = scrollLock.body.paddingRight || '';
    }
    scrollLock.locked = false;
    window.scrollTo(0, scrollY);
  }

  function hasVisibleCustomizeDialog() {
    return !!document.querySelector('[data-av-customize-dialog]:not([hidden])');
  }

  function setDialogLayer(root, isOpen) {
    var section = root && root.closest('.shopify-section');
    [root, section].forEach(function (node) {
      if (!node) return;
      node.classList.toggle('av-customize-dialog-is-open', isOpen);
    });
  }



  function updateDialogScrollCue(dialog) {
    var body = dialog && dialog.querySelector('.av-product-hero__customize-dialog-body');
    if (!body) return;

    var scrollable = body.scrollHeight > body.clientHeight + 4;
    var atTop = body.scrollTop <= 2;
    var atBottom = !scrollable || body.scrollTop + body.clientHeight >= body.scrollHeight - 4;

    body.classList.toggle('is-scrollable', scrollable);
    body.classList.toggle('is-at-top', atTop);
    body.classList.toggle('is-at-bottom', atBottom);
  }

  function ensureDialogScrollIndicator(dialog) {
    var sheet = dialog && dialog.querySelector('.av-product-hero__customize-dialog-sheet');
    if (!sheet) return null;

    var indicator = sheet.querySelector('[data-av-dialog-scroll-indicator]');
    if (indicator) return indicator;

    indicator = document.createElement('span');
    indicator.className = 'av-product-hero__customize-scroll-indicator';
    indicator.setAttribute('data-av-dialog-scroll-indicator', '');
    indicator.setAttribute('aria-hidden', 'true');

    var thumb = document.createElement('span');
    thumb.className = 'av-product-hero__customize-scroll-indicator-thumb';
    indicator.appendChild(thumb);

    sheet.appendChild(indicator);
    return indicator;
  }

  function updateDialogScrollIndicator(dialog) {
    var body = dialog && dialog.querySelector('.av-product-hero__customize-dialog-body');
    var sheet = dialog && dialog.querySelector('.av-product-hero__customize-dialog-sheet');
    var indicator = ensureDialogScrollIndicator(dialog);
    if (!body || !sheet || !indicator) return;

    var scrollable = body.scrollHeight > body.clientHeight + 4;
    indicator.classList.toggle('is-visible', scrollable);
    body.classList.toggle('has-persistent-scroll-indicator', scrollable);

    if (!scrollable) return;

    var bodyRect = body.getBoundingClientRect();
    var sheetRect = sheet.getBoundingClientRect();

    var trackTop = Math.max(0, bodyRect.top - sheetRect.top + 6);
    var trackHeight = Math.max(32, bodyRect.height - 12);

    var thumbHeight = Math.max(
      28,
      Math.min(trackHeight, trackHeight * (body.clientHeight / Math.max(body.scrollHeight, 1)))
    );

    var maxScroll = Math.max(1, body.scrollHeight - body.clientHeight);
    var maxTravel = Math.max(0, trackHeight - thumbHeight);
    var progress = Math.min(1, Math.max(0, body.scrollTop / maxScroll));
    var thumbY = maxTravel * progress;

    indicator.style.setProperty('--av-scroll-indicator-top', trackTop + 'px');
    indicator.style.setProperty('--av-scroll-indicator-height', trackHeight + 'px');
    indicator.style.setProperty('--av-scroll-thumb-height', thumbHeight + 'px');
    indicator.style.setProperty('--av-scroll-thumb-y', thumbY + 'px');
  }

  function bindDialogScrollCue(dialog) {
    var body = dialog && dialog.querySelector('.av-product-hero__customize-dialog-body');
    if (!body || body.dataset.avScrollCueReady === 'true') return;

    body.dataset.avScrollCueReady = 'true';
    body.addEventListener('scroll', function () {
      updateDialogScrollCue(dialog);
      updateDialogScrollIndicator(dialog);
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('[id^="av-product-hero-"]').forEach(initRoot);
  }

  function initRoot(root) {
    if (!root || root.dataset.avPersonalizationHubReady === 'true') return;
    if (!root.querySelector('[data-av-customize-hub]')) return;
    root.dataset.avPersonalizationHubReady = 'true';
    state.set(root, { openDialog: null, opener: null, draft: {}, masterEnabled: false, inactiveSnapshot: null });

    root.addEventListener('click', function (event) {
      var row = event.target.closest('[data-av-customize-open]');
      if (row && root.contains(row)) {
        var data = state.get(root) || {};
        if (data.masterEnabled === false) {
          setMasterEnabled(root, true);
        }
        openDialog(root, row.dataset.avCustomizeOpen, { opener: row });
        return;
      }
      var dialog = event.target.closest('[data-av-customize-dialog]');
      if (!dialog || !root.contains(dialog)) return;
      var modeChoice = event.target.closest('[data-av-icon-mode-choice]');
      if (modeChoice) {
        event.preventDefault();
        setIconRequestMode(root, modeChoice.dataset.avIconModeChoice || 'independent');
        return;
      }
      if (event.target.closest('[data-av-customize-close]')) closeDialog(root);
      if (event.target.closest('[data-av-customize-save]')) saveDraftToBacking(root, dialog.dataset.avCustomizeDialog);
      if (event.target.closest('[data-av-customize-clear]')) clearBackingSelection(root, dialog.dataset.avCustomizeDialog);
    });

    root.addEventListener('input', function (event) {
      var input = event.target.closest('[data-av-customize-draft]');
      if (input) {
        var key = input.dataset.avCustomizeDraft.split(':')[0];
        clearError(root, key);
        updateCount(root, key);
      }
      window.setTimeout(function () { updateAllSummaries(root); }, 0);
    });
    root.addEventListener('change', function () { window.setTimeout(function () { updateAllSummaries(root); }, 0); });
    root.addEventListener('keydown', function (event) {
      var draft = event.target.closest('[data-av-customize-draft]');
      if (!draft || !root.contains(draft)) return;
      if (event.key !== 'Enter') return;
      var dialog = event.target.closest('[data-av-customize-dialog]');
      if (!dialog || !root.contains(dialog)) return;
      event.preventDefault();
      saveDraftToBacking(root, dialog.dataset.avCustomizeDialog);
    });

    document.addEventListener('keydown', function (event) {
      var data = state.get(root);
      if (!data || !data.openDialog) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog(root);
      } else if (event.key === 'Tab') {
        trapFocus(event, data.openDialog);
      }
    });

    var observer = new MutationObserver(function () {
      window.clearTimeout(root.avCustomizeHubTimer);
      root.avCustomizeHubTimer = window.setTimeout(function () {
        updateRowVisibility(root);
        updateAllSummaries(root);
        rebuildOpenChoices(root);
      }, 40);
    });
    var backingArea = root.querySelector('[data-av-personalize-backing]') || root.querySelector('.av-product-hero__personalize-fields');
    if (backingArea) {
      observer.observe(backingArea, { childList: true, subtree: true, attributes: true, characterData: true, attributeFilter: ['class', 'hidden', 'disabled', 'selected'] });
    }

    var disclosure = root.querySelector('[data-av-personalize-disclosure]');
    var enabled = hasActivePersonalization(root) || (disclosure && disclosure.getAttribute('aria-expanded') === 'true');
    setMasterEnabled(root, enabled, {
      restore: false,
      skipCapture: true,
      managePanel: false
    });

    var form = root.querySelector('form[action*="/cart/add"], form.av-product-hero__form');
    if (form) {
      form.addEventListener('submit', function () {
        var data = state.get(root) || {};
        if (!data.masterEnabled) {
          scrubActiveCustomization(root);
        }
      }, true);
    }

    updateRowVisibility(root);
    ['custom_text', 'stock_icon', 'extra_color'].forEach(function (key) { updateFeeNote(root, key); });
    updateAllSummaries(root);
  }

  function backing(root, key) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-av-addon-option="' + key + '"]'));
  }

  function firstBacking(root, key) {
    return backing(root, key).filter(isUsable)[0] || backing(root, key)[0] || null;
  }

  function isUsable(option) {
    return !!option && !option.classList.contains('av-addon-is-hidden') && !option.closest('.av-ui-section-is-hidden');
  }

  function getToggle(option) { return option && option.querySelector('.av-personalize-toggle'); }
  function getControl(option) { return option && option.querySelector('.av-personalize-control'); }
  function getName(option) { return text(option && option.querySelector('.av-product-hero__personalize-name')); }
  function getPrice(option) { return text(option && option.querySelector('.av-product-hero__price-pill')) || '+$2.00'; }
  function text(node) { return node ? (node.textContent || '').trim() : ''; }


  function hasActivePersonalization(root) {
    return ['custom_text', 'stock_icon', 'extra_color'].some(function (key) {
      return backing(root, key).filter(isUsable).some(function (option) {
        var toggle = getToggle(option);
        var control = getControl(option);
        return !!(toggle && toggle.checked && (!control || control.value));
      });
    });
  }

  function captureBuilderValues(root, names) {
    var values = {};
    names.forEach(function (name) {
      var select = root.querySelector('[data-av-builder-control="' + name + '"]');
      if (select) values[name] = select.value || '';
    });
    return values;
  }

  function restoreBuilderValues(root, values) {
    Object.keys(values || {}).forEach(function (name) {
      setNativeSelectValue(root.querySelector('[data-av-builder-control="' + name + '"]'), values[name]);
    });
  }

  function captureOptionSnapshot(option, index) {
    var toggle = getToggle(option);
    var control = getControl(option);
    return {
      index: index,
      key: option && (option.dataset.avAddonOptionKey || option.dataset.avAddonVariantId || option.id || ''),
      enabled: !!(toggle && toggle.checked),
      value: control ? (control.value || '') : ''
    };
  }

  function captureCustomizationSnapshot(root) {
    var customText = firstBacking(root, 'custom_text');
    var stockIcon = firstBacking(root, 'stock_icon');
    return {
      custom_text: Object.assign(captureOptionSnapshot(customText, 0), {
        builder: captureBuilderValues(root, ['text-color', 'text-horizontal', 'text-vertical', 'text-orientation', 'text-surface', 'text-font'])
      }),
      stock_icon: Object.assign(captureOptionSnapshot(stockIcon, 0), {
        builder: captureBuilderValues(root, ['icon-relation', 'icon-horizontal', 'icon-vertical', 'icon-orientation', 'icon-surface'])
      }),
      extra_color: backing(root, 'extra_color').filter(isUsable).map(captureOptionSnapshot)
    };
  }

  function optionFromSnapshot(root, key, item) {
    var options = backing(root, key).filter(isUsable);
    if (item && item.key) {
      for (var i = 0; i < options.length; i++) {
        var stable = options[i].dataset.avAddonOptionKey || options[i].dataset.avAddonVariantId || options[i].id || '';
        if (stable && stable === item.key) return options[i];
      }
    }
    return options[item && typeof item.index === 'number' ? item.index : 0] || null;
  }

  function restoreOptionSnapshot(root, key, item) {
    if (!item || !item.enabled || !item.value) return;
    var option = optionFromSnapshot(root, key, item);
    var toggle = getToggle(option);
    var control = getControl(option);
    if (control) {
      control.disabled = false;
      setNativeSelectValue(control, item.value);
      dispatchNativeChange(control, 'input');
    }
    if (toggle && !toggle.checked) {
      toggle.checked = true;
      dispatchNativeChange(toggle);
    }
  }

  function restoreCustomizationSnapshot(root, snapshot) {
    if (!snapshot) {
      updateAllSummaries(root);
      return;
    }
    restoreOptionSnapshot(root, 'custom_text', snapshot.custom_text);
    restoreBuilderValues(root, snapshot.custom_text && snapshot.custom_text.builder);
    restoreOptionSnapshot(root, 'stock_icon', snapshot.stock_icon);
    restoreBuilderValues(root, snapshot.stock_icon && snapshot.stock_icon.builder);
    (snapshot.extra_color || []).forEach(function (item) { restoreOptionSnapshot(root, 'extra_color', item); });
    updateAllSummaries(root);
  }

  function scrubActiveCustomization(root) {
    ['custom_text', 'stock_icon', 'extra_color'].forEach(function (key) {
      backing(root, key).forEach(function (option) {
        var toggle = getToggle(option);
        var control = getControl(option);
        if (toggle && toggle.checked) {
          toggle.checked = false;
          dispatchNativeChange(toggle);
        }
        if (control) {
          control.value = '';
          control.disabled = true;
          dispatchNativeChange(control, 'input');
          dispatchNativeChange(control);
        }
      });
    });
    updateAllSummaries(root);
  }

  function setMasterEnabled(root, enabled, opts) {
    opts = opts || {};
    var managePanel = opts.managePanel !== false;
    var data = state.get(root) || {};
    var disclosure = root.querySelector('[data-av-personalize-disclosure]');
    var panel = root.querySelector('[data-av-personalize-panel]');
    var heading = root.querySelector('.av-product-hero__personalize-heading');

    if (!enabled) {
      if (!opts.skipCapture && hasActivePersonalization(root)) {
        data.inactiveSnapshot = captureCustomizationSnapshot(root);
      }
      data.masterEnabled = false;
      state.set(root, data);
      scrubActiveCustomization(root);
      if (disclosure) {
        disclosure.setAttribute('aria-pressed', 'false');
      }
      if (managePanel) {
        if (disclosure) disclosure.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.hidden = true;
          panel.classList.remove('is-open');
          panel.style.maxHeight = '0px';
          panel.style.opacity = '0';
        }
        if (heading) heading.classList.remove('is-open');
      }
      root.classList.add('av-customize-master-is-off');
      root.classList.remove('av-customize-master-is-on');
      return;
    }

    data.masterEnabled = true;
    state.set(root, data);
    if (opts.restore !== false) restoreCustomizationSnapshot(root, data.inactiveSnapshot);
    else updateAllSummaries(root);
    if (disclosure) {
      disclosure.setAttribute('aria-pressed', 'true');
    }
    if (managePanel) {
      if (disclosure) disclosure.setAttribute('aria-expanded', 'true');
      if (panel) {
        panel.hidden = false;
        panel.classList.add('is-open');
        panel.style.opacity = '1';
        panel.style.maxHeight = 'none';
      }
      if (heading) heading.classList.add('is-open');
    }
    root.classList.add('av-customize-master-is-on');
    root.classList.remove('av-customize-master-is-off');
  }

  function openDialog(root, key, optionalContext) {
    var dialog = root.querySelector('[data-av-customize-dialog="' + key + '"]');
    if (!dialog) return;
    closeDialog(root, { skipFocus: true, keepLocked: true });
    var data = state.get(root) || {};
    data.openDialog = dialog;
    data.opener = optionalContext && optionalContext.opener;
    state.set(root, data);
    syncDraftFromBacking(root, key);
    dialog.hidden = false;
    bindDialogScrollCue(dialog);
    updateDialogScrollCue(dialog);
    ensureDialogScrollIndicator(dialog);
    updateDialogScrollIndicator(dialog);
    requestAnimationFrame(function () {
      updateDialogScrollCue(dialog);
      updateDialogScrollIndicator(dialog);
    });
    setTimeout(function () {
      updateDialogScrollCue(dialog);
      updateDialogScrollIndicator(dialog);
    }, 120);
    setDialogLayer(root, true);
    lockPageScroll();
    var first = dialog.querySelector(FOCUSABLE);
    if (first) first.focus({ preventScroll: true });
  }

  function closeDialog(root, opts) {
    var data = state.get(root);
    if (!data || !data.openDialog) return;
    var closingDialog = data.openDialog;
    var closingBody = closingDialog && closingDialog.querySelector('.av-product-hero__customize-dialog-body');
    if (closingBody) closingBody.classList.remove('is-scrollable', 'is-at-top', 'is-at-bottom', 'has-persistent-scroll-indicator');
    var indicator = closingDialog && closingDialog.querySelector('[data-av-dialog-scroll-indicator]');
    if (indicator) indicator.classList.remove('is-visible');
    closingDialog.hidden = true;
    setDialogLayer(root, false);
    if (!opts || !opts.keepLocked) {
      if (!hasVisibleCustomizeDialog()) unlockPageScroll();
    }
    var opener = data.opener;
    data.openDialog = null;
    data.opener = null;
    state.set(root, data);
    if (!opts || !opts.skipFocus) {
      if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
    }
  }

  function syncDraftFromBacking(root, key) {
    clearError(root, key);
    if (key === 'custom_text' || key === 'stock_icon') {
      var option = firstBacking(root, key);
      var control = getControl(option);
      var draft = root.querySelector('[data-av-customize-draft="' + key + ':value"]');
      if (draft && control) {
        draft.value = control.value || '';
        if (control.maxLength > 0) draft.maxLength = control.maxLength;
        if (control.placeholder) draft.placeholder = control.placeholder;
      }
      ['text-color', 'text-horizontal', 'text-vertical', 'text-orientation', 'icon-relation', 'icon-horizontal', 'icon-vertical', 'icon-orientation'].forEach(function (name) {
        var select = root.querySelector('[data-av-builder-control="' + name + '"]');
        var container = root.querySelector('[data-av-customize-choices="' + name + '"]');
        if (container) buildChoiceButtonsFromSelect(select, container, { renderWhenHidden: key === 'stock_icon' && (name === 'icon-relation' || name === 'icon-horizontal' || name === 'icon-vertical') });
      });
      updateCount(root, key);
      if (key === 'stock_icon') syncIconRequestMode(root);
    }
    if (key === 'extra_color') buildColorEditor(root);
    updateFeeNote(root, key);
  }

  function saveDraftToBacking(root, key) {
    if (key === 'custom_text' || key === 'stock_icon') {
      var option = firstBacking(root, key);
      var control = getControl(option);
      var toggle = getToggle(option);
      var draft = root.querySelector('[data-av-customize-draft="' + key + ':value"]');
      var value = draft ? draft.value.trim() : '';
      if (!value) { showError(root, key); return; }
      clearError(root, key);
      if (control) { control.value = value; control.disabled = false; dispatchNativeChange(control, 'input'); dispatchNativeChange(control); }
      if (toggle && !toggle.checked) { toggle.checked = true; dispatchNativeChange(toggle); }
      var prefix = key === 'custom_text' ? 'text' : 'icon';
      var dialog = root.querySelector('[data-av-customize-dialog="' + key + '"]');
      if (key === 'stock_icon') normalizeIconRequestBeforeSave(root, dialog);
      Array.prototype.slice.call(
        dialog ? dialog.querySelectorAll('[data-av-customize-choice].is-selected') : []
      ).forEach(function (button) {
        var name = button.dataset.avCustomizeChoice;
        if (!name || name.indexOf(prefix + '-') !== 0) return;
        setNativeSelectValue(root.querySelector('[data-av-builder-control="' + name + '"]'), button.dataset.value || '');
      });
    } else if (key === 'extra_color') {
      var colorDialog = root.querySelector('[data-av-customize-dialog="extra_color"]');
      Array.prototype.slice.call(
        colorDialog ? colorDialog.querySelectorAll('[data-av-color-choice].is-selected') : []
      ).forEach(function (button) {
        var option = root.querySelector('[data-av-addon-option="extra_color"][data-av-color-editor-index="' + button.dataset.avColorIndex + '"]');
        var select = getControl(option);
        var toggle = getToggle(option);
        setNativeSelectValue(select, button.dataset.value || '');
        if (toggle && !toggle.checked) {
          toggle.checked = true;
          dispatchNativeChange(toggle);
        }
      });
    }
    closeDialog(root);
    updateAllSummaries(root);
    syncIconRequestMode(root);
  }

  function clearBackingSelection(root, key) {
    var shouldCenterIconAfterTextClear = false;

    if (key === 'custom_text') {
      var relationBeforeClear = root.querySelector('[data-av-builder-control="icon-relation"]');
      shouldCenterIconAfterTextClear =
        hasActiveStockIcon(root) &&
        relationBeforeClear &&
        getIconRelationModeFromValue(relationBeforeClear.value, selectedText(relationBeforeClear)) === 'text';
    }

    backing(root, key).forEach(function (option) {
      var toggle = getToggle(option);
      var control = getControl(option);
      if (toggle) { toggle.checked = false; dispatchNativeChange(toggle); }
      if (control) { control.value = ''; dispatchNativeChange(control, 'input'); dispatchNativeChange(control); }
    });

    if (key === 'custom_text') {
      normalizeIconAfterCustomTextCleared(root, {
        forceCenter: shouldCenterIconAfterTextClear
      });
    }

    closeDialog(root);
    updateAllSummaries(root);
    syncIconRequestMode(root);
  }

  function setRowPrice(root, key, selected, option) {
    var price = root.querySelector('[data-av-customize-row-price="' + key + '"]');
    if (!price) return;
    price.textContent = selected ? getPrice(option) : '';
  }

  function updateAllSummaries(root) {
    var data = state.get(root) || {};
    var masterEnabled = data.masterEnabled !== false;
    ['custom_text', 'stock_icon', 'extra_color'].forEach(function (key) {
      var option = firstBacking(root, key);
      var row = root.querySelector('[data-av-customize-row="' + key + '"]');
      var summary = root.querySelector('[data-av-customize-summary="' + key + '"]');
      var label = root.querySelector('[data-av-customize-label="' + key + '"]');
      if (!row || !summary) return;
      summary.innerHTML = '';
      if (label && option) label.textContent = key === 'extra_color' ? colorTitle(root) : (getName(option) || label.textContent);
      if (!masterEnabled) {
        row.classList.remove('is-selected');
        setRowAction(row, false);
        setRowPrice(root, key, false, option);
        return;
      }
      var selected = false;
      if (key === 'extra_color') {
        backing(root, key).filter(isUsable).forEach(function (opt) {
          var toggle = getToggle(opt), control = getControl(opt);
          if (toggle && toggle.checked && control && control.value) {
            selected = true;
            addPill(summary, (getName(opt) || 'Color') + ': ' + selectedText(control), true, control.value);
          }
        });
      } else {
        var control = getControl(option);
        var toggle = getToggle(option);
        selected = !!(toggle && toggle.checked && control && control.value);
        if (selected) {
          addPill(summary, (key === 'custom_text' ? 'Text: ' : '') + control.value);
          if (key === 'custom_text') {
            ['text-color', 'text-horizontal', 'text-vertical', 'text-orientation'].forEach(function (name) {
              var select = root.querySelector('[data-av-builder-control="' + name + '"]');
              if (select && select.value) addPill(summary, selectedText(select));
            });
          } else {
            var relationSelect = root.querySelector('[data-av-builder-control="icon-relation"]');
            var relationMode = relationSelect && relationSelect.value
              ? getIconRelationModeFromValue(relationSelect.value, selectedText(relationSelect))
              : 'other';

            if (relationSelect && relationSelect.value) addPill(summary, selectedText(relationSelect));

            if (relationMode === 'independent') {
              ['icon-horizontal', 'icon-vertical'].forEach(function (name) {
                var select = root.querySelector('[data-av-builder-control="' + name + '"]');
                if (select && select.value) addPill(summary, selectedText(select));
              });
            }
          }
        }
      }
      setRowPrice(root, key, selected, option);
      row.classList.toggle('is-selected', selected);
      setRowAction(row, selected);
    });
  }

  function updateRowVisibility(root) {
    ['custom_text', 'stock_icon', 'extra_color'].forEach(function (key) {
      var row = root.querySelector('[data-av-customize-row="' + key + '"]');
      if (row) row.hidden = backing(root, key).filter(isUsable).length === 0;
    });
  }

  function buildChoiceButtonsFromSelect(select, container, opts) {
    opts = opts || {};
    var field = container && container.closest('[data-av-customize-field]');
    if (!container || !field) return;
    container.innerHTML = '';
    if (!select || (!opts.renderWhenHidden && select.hidden) || !select.options || select.options.length === 0) { field.hidden = true; return; }
    field.hidden = false;
    Array.prototype.slice.call(select.options).forEach(function (option) {
      if (!option.value) return;
      var button = document.createElement('button');
      button.type = 'button';
      var isTextColor = select.dataset.avBuilderControl === 'text-color';
      button.className = 'av-product-hero__customize-choice' + (isTextColor ? ' av-product-hero__customize-color-option' : '') + (option.selected ? ' is-selected' : '');
      button.dataset.avCustomizeChoice = select.dataset.avBuilderControl;
      button.dataset.value = option.value;
      if (isTextColor) {
        var swatch = document.createElement('span');
        swatch.className = 'av-product-hero__customize-color-swatch';
        swatch.style.setProperty('--av-swatch', colorToCss(option.value));
        var label = document.createElement('span');
        label.textContent = option.textContent.trim() || option.value;
        var check = document.createElement('span');
        check.className = 'av-product-hero__customize-color-check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        button.appendChild(swatch);
        button.appendChild(label);
        button.appendChild(check);
      } else {
        button.textContent = option.textContent.trim() || option.value;
      }
      button.setAttribute('aria-pressed', String(select.value) === String(option.value));
      button.addEventListener('click', function () {
        container.querySelectorAll('.is-selected').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
      });
      container.appendChild(button);
    });
    field.hidden = container.children.length === 0;
  }


  function ensureIconDraftChoices(root, dialog, names) {
    (names || ['icon-relation', 'icon-horizontal', 'icon-vertical']).forEach(function (name) {
      var select = root.querySelector('[data-av-builder-control="' + name + '"]');
      var container = dialog && dialog.querySelector('[data-av-customize-choices="' + name + '"]');
      if (select && container && !container.children.length) {
        buildChoiceButtonsFromSelect(select, container, { renderWhenHidden: true });
      }
    });
  }

  function ensureSelectedDraftChoice(root, dialog, name, matcher) {
    var select = root.querySelector('[data-av-builder-control="' + name + '"]');
    var container = dialog && dialog.querySelector('[data-av-customize-choices="' + name + '"]');
    if (!container || !container.children.length) return;
    var buttons = Array.prototype.slice.call(container.querySelectorAll('[data-av-customize-choice="' + name + '"]'));
    if (!buttons.length || buttons.some(function (button) { return button.classList.contains('is-selected'); })) return;

    var value = select && select.value ? select.value : '';
    var selected = null;
    if (value) {
      selected = buttons.filter(function (button) { return String(button.dataset.value) === String(value); })[0] || null;
    }
    if (!selected && matcher) {
      selected = buttons.filter(function (button) {
        var text = String(button.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();
        var buttonValue = String(button.dataset.value || '').toLowerCase().replace(/\s+/g, ' ').trim();
        return matcher(text, buttonValue);
      })[0] || null;
    }
    setChoiceSelected(selected || buttons[0], true);
  }

  function ensureIconIndependentDraftDefaults(root, dialog) {
    ensureIconDraftChoices(root, dialog, ['icon-horizontal', 'icon-vertical']);
    var centerMatcher = function (text, value) {
      return text === 'center' || value === 'center' || text.indexOf('center') !== -1 || value.indexOf('center') !== -1;
    };
    ensureSelectedDraftChoice(root, dialog, 'icon-horizontal', centerMatcher);
    ensureSelectedDraftChoice(root, dialog, 'icon-vertical', centerMatcher);
  }


  function hasActiveCustomText(root) {
    var option = firstBacking(root, 'custom_text');
    var toggle = getToggle(option);
    var control = getControl(option);
    var value = control && typeof control.value === 'string' ? control.value.trim() : '';
    return !!(toggle && toggle.checked && value);
  }

  function hasActiveStockIcon(root) {
    var option = firstBacking(root, 'stock_icon');
    var toggle = getToggle(option);
    var control = getControl(option);
    var value = control && typeof control.value === 'string' ? control.value.trim() : '';
    return !!(toggle && toggle.checked && value);
  }

  function getIconRelationModeFromValue(value, label) {
    var raw = String((value || '') + ' ' + (label || '')).toLowerCase().replace(/\s+/g, ' ').trim();

    if (
      raw.indexOf('custom position') !== -1 ||
      raw.indexOf('custom position on lid') !== -1 ||
      raw.indexOf('independent') !== -1 ||
      raw.indexOf('independent position') !== -1 ||
      raw.indexOf('position on lid') !== -1 ||
      raw.trim() === 'custom'
    ) {
      return 'independent';
    }

    if (
      raw.indexOf('left of text') !== -1 ||
      raw.indexOf('right of text') !== -1 ||
      raw.indexOf('above text') !== -1 ||
      raw.indexOf('below text') !== -1 ||
      raw.indexOf('above the text') !== -1 ||
      raw.indexOf('below the text') !== -1 ||
      raw.indexOf('above of text') !== -1 ||
      raw.indexOf('below of text') !== -1 ||
      raw.indexOf('top of text') !== -1 ||
      raw.indexOf('bottom of text') !== -1
    ) {
      return 'text';
    }

    return 'other';
  }

  function getIconRelationButtons(dialog) {
    return Array.prototype.slice.call(dialog ? dialog.querySelectorAll('[data-av-customize-choice="icon-relation"]') : []);
  }

  function getIconIndependentRelationButton(dialog) {
    return getIconRelationButtons(dialog).filter(function (button) {
      return getIconRelationModeFromValue(button.dataset.value, button.textContent) === 'independent';
    })[0] || null;
  }

  function getIconTextRelationButtons(dialog) {
    return getIconRelationButtons(dialog).filter(function (button) {
      return getIconRelationModeFromValue(button.dataset.value, button.textContent) === 'text';
    });
  }

  function setChoiceSelected(button, selected) {
    if (!button) return;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
  }

  function refreshIconModeUi(root, dialog, mode) {
    ensureIconDraftChoices(root, dialog, ['icon-relation']);
    var textActive = hasActiveCustomText(root);
    var textChoice = dialog && dialog.querySelector('[data-av-icon-mode-choice="text"]');
    var independentChoice = dialog && dialog.querySelector('[data-av-icon-mode-choice="independent"]');
    var textPanel = dialog && dialog.querySelector('[data-av-icon-mode-panel="text"]');
    var independentPanel = dialog && dialog.querySelector('[data-av-icon-mode-panel="independent"]');
    var note = dialog && dialog.querySelector('[data-av-icon-mode-note]');
    mode = textActive && mode === 'text' ? 'text' : 'independent';
    if (mode === 'independent') ensureIconIndependentDraftDefaults(root, dialog);
    if (textChoice) {
      textChoice.disabled = !textActive;
      textChoice.classList.toggle('is-disabled', !textActive);
      setChoiceSelected(textChoice, mode === 'text');
    }
    setChoiceSelected(independentChoice, mode === 'independent');
    if (note) note.hidden = textActive;
    if (textPanel) textPanel.hidden = mode !== 'text';
    if (independentPanel) independentPanel.hidden = mode !== 'independent';
    getIconRelationButtons(dialog).forEach(function (button) {
      var relationMode = getIconRelationModeFromValue(button.dataset.value, button.textContent);
      var hideFromTextPanel = relationMode !== 'text';

      button.hidden = hideFromTextPanel;
      button.classList.toggle('av-icon-relation-is-hidden', hideFromTextPanel);
      button.setAttribute('data-av-icon-relation-mode', relationMode);
      button.setAttribute('data-av-icon-relation-hidden', hideFromTextPanel ? 'true' : 'false');
    });
    updateDialogScrollCue(dialog);
    updateDialogScrollIndicator(dialog);
  }

  function setIconRequestMode(root, mode) {
    var dialog = root.querySelector('[data-av-customize-dialog="stock_icon"]');
    if (!dialog) return;
    ensureIconDraftChoices(root, dialog, ['icon-relation']);
    if (mode === 'text' && !hasActiveCustomText(root)) mode = 'independent';
    var independent = getIconIndependentRelationButton(dialog);
    var textButtons = getIconTextRelationButtons(dialog);
    if (mode === 'text') {
      setChoiceSelected(independent, false);
      if (!textButtons.some(function (button) { return button.classList.contains('is-selected'); })) {
        setChoiceSelected(textButtons[0], true);
      }
    } else {
      ensureIconIndependentDraftDefaults(root, dialog);
      textButtons.forEach(function (button) { setChoiceSelected(button, false); });
      setChoiceSelected(independent || getIconRelationButtons(dialog)[0], true);
    }
    refreshIconModeUi(root, dialog, mode);
  }

  function syncIconRequestMode(root) {
    var dialog = root.querySelector('[data-av-customize-dialog="stock_icon"]');
    if (!dialog) return;

    var textActive = hasActiveCustomText(root);
    var stockIconActive = hasActiveStockIcon(root);
    var selected = getIconRelationButtons(dialog).filter(function (button) {
      return button.classList.contains('is-selected');
    })[0];

    var selectedMode = selected ? getIconRelationModeFromValue(selected.dataset.value, selected.textContent) : 'other';

    if (!stockIconActive && textActive) {
      setIconRequestMode(root, 'text');
      return;
    }

    if (selectedMode === 'text' && textActive) {
      refreshIconModeUi(root, dialog, 'text');
      return;
    }

    if (selectedMode === 'independent') {
      refreshIconModeUi(root, dialog, 'independent');
      return;
    }

    setIconRequestMode(root, 'independent');
  }

  function clearIconIndependentDraftChoices(dialog) {
    Array.prototype.slice.call(
      dialog
        ? dialog.querySelectorAll('[data-av-customize-choice="icon-horizontal"], [data-av-customize-choice="icon-vertical"]')
        : []
    ).forEach(function (button) {
      setChoiceSelected(button, false);
    });
  }

  function clearIconIndependentBacking(root) {
    ['icon-horizontal', 'icon-vertical'].forEach(function (name) {
      var select = root.querySelector('[data-av-builder-control="' + name + '"]');
      if (!select) return;

      var previous = select.value;
      var next = '';

      if (select.options && select.options.length) {
        var blank = Array.prototype.slice.call(select.options).filter(function (option) {
          return option.value === '';
        })[0];

        next = blank ? blank.value : '';
      }

      if (String(previous) !== String(next)) {
        setNativeSelectValue(select, next);
      }
    });
  }

  function clearIconOrientationBacking(root) {
    var select = root.querySelector('[data-av-builder-control="icon-orientation"]');
    if (!select || !select.options || !select.options.length) return;
    var next = select.options[0].value;
    Array.prototype.slice.call(select.options).some(function (option) {
      if (!option.value) { next = option.value; return true; }
      if (String(option.textContent || option.value).toLowerCase().indexOf('horizontal') !== -1) { next = option.value; return true; }
      return false;
    });
    if (String(select.value) !== String(next)) setNativeSelectValue(select, next);
  }


  function findOptionValueByText(select, matcher) {
    if (!select || !select.options) return '';
    var found = Array.prototype.slice.call(select.options).filter(function (option) {
      var text = String(option.textContent || option.value || '').toLowerCase().replace(/\s+/g, ' ').trim();
      var value = String(option.value || '').toLowerCase().replace(/\s+/g, ' ').trim();
      return matcher(text, value);
    })[0];

    return found ? found.value : '';
  }

  function setIconIndependentCenterDefaults(root) {
    var relation = root.querySelector('[data-av-builder-control="icon-relation"]');
    var horizontal = root.querySelector('[data-av-builder-control="icon-horizontal"]');
    var vertical = root.querySelector('[data-av-builder-control="icon-vertical"]');

    var independentValue = findOptionValueByText(relation, function (text, value) {
      return text.indexOf('custom position') !== -1 ||
        text.indexOf('independent') !== -1 ||
        text.indexOf('position on lid') !== -1 ||
        value === 'custom' ||
        value === 'independent';
    });

    var centerHorizontal = findOptionValueByText(horizontal, function (text, value) {
      return text === 'center' || value === 'center' || text.indexOf('center') !== -1 || value.indexOf('center') !== -1;
    });

    var centerVertical = findOptionValueByText(vertical, function (text, value) {
      return text === 'center' || value === 'center' || text.indexOf('center') !== -1 || value.indexOf('center') !== -1;
    });

    if (independentValue && relation) setNativeSelectValue(relation, independentValue);
    if (centerHorizontal && horizontal) setNativeSelectValue(horizontal, centerHorizontal);
    if (centerVertical && vertical) setNativeSelectValue(vertical, centerVertical);

    clearIconOrientationBacking(root);
  }

  function normalizeIconAfterCustomTextCleared(root, opts) {
    opts = opts || {};
    if (!hasActiveStockIcon(root)) return;

    var relation = root.querySelector('[data-av-builder-control="icon-relation"]');
    if (!relation) return;

    var relationMode = relation.value
      ? getIconRelationModeFromValue(relation.value, selectedText(relation))
      : 'other';

    if (!opts.forceCenter && relationMode !== 'text') return;

    setIconIndependentCenterDefaults(root);
  }

  function normalizeIconRequestBeforeSave(root, dialog) {
    if (!dialog) return;

    var textSelected = getIconTextRelationButtons(dialog).some(function (button) {
      return button.classList.contains('is-selected');
    });

    var mode = textSelected && hasActiveCustomText(root) ? 'text' : 'independent';

    setIconRequestMode(root, mode);

    if (mode === 'text') {
      clearIconIndependentDraftChoices(dialog);
      clearIconIndependentBacking(root);
    }

    clearIconOrientationBacking(root);
  }

  function buildColorEditor(root) {
    var body = root.querySelector('[data-av-customize-color-body]');
    if (!body) return;
    body.innerHTML = '';
    var options = backing(root, 'extra_color').filter(isUsable);
    var title = root.querySelector('[data-av-customize-title="extra_color"]');
    var renderedNames = [];
    options.forEach(function (option, index) {
      option.dataset.avColorEditorIndex = String(index);
      var select = getControl(option);
      if (!select || select.options.length === 0) return;
      var field = document.createElement('div');
      field.className = 'av-product-hero__customize-choice-field av-product-hero__customize-dialog-section av-product-hero__customize-choice-field--extra-color';
      var label = document.createElement('span');
      label.textContent = getName(option) || 'Color Add-On';
      var grid = document.createElement('div');
      grid.className = 'av-product-hero__customize-choice-grid av-product-hero__customize-color-grid av-product-hero__customize-extra-color-grid';
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        if (!opt.value) return;
        var button = document.createElement('button');
        button.type = 'button';
        var isSelected = String(select.value) === String(opt.value);
        button.className = 'av-product-hero__customize-choice av-product-hero__customize-color-option av-product-hero__customize-extra-color-option' + (isSelected ? ' is-selected' : '');
        button.dataset.avColorChoice = 'true';
        button.dataset.avColorIndex = String(index);
        button.dataset.value = opt.value;
        var swatch = document.createElement('span');
        swatch.className = 'av-product-hero__customize-color-swatch';
        swatch.style.setProperty('--av-swatch', colorToCss(opt.value));
        var choiceLabel = document.createElement('span');
        choiceLabel.textContent = opt.textContent.trim() || opt.value;
        var check = document.createElement('span');
        check.className = 'av-product-hero__customize-color-check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        button.appendChild(swatch);
        button.appendChild(choiceLabel);
        button.appendChild(check);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        button.addEventListener('click', function () {
          grid.querySelectorAll('.is-selected').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
        });
        grid.appendChild(button);
      });
      if (!grid.children.length) return;
      field.appendChild(label); field.appendChild(grid); body.appendChild(field);
      renderedNames.push(getName(option) || 'Color Add-On');
    });
    if (title) title.textContent = renderedNames.length === 1 ? (renderedNames[0] || 'Lid Color') : (renderedNames.length > 1 ? 'Color Add-Ons' : 'Lid Color');
    if (!body.children.length) {
      var p = document.createElement('p'); p.className = 'av-product-hero__customize-note'; p.textContent = 'No color add-ons are available for the current selections.'; body.appendChild(p);
    }
  }

  function colorTitle(root) {
    var options = backing(root, 'extra_color').filter(isUsable);
    return options.length === 1 ? (getName(options[0]) || 'Lid Color') : 'Color Add-Ons';
  }

  function setRowAction(row, selected) {
    if (!row) return;
    var label = row.querySelector('[data-av-customize-action-label]');
    var symbol = row.querySelector('[data-av-customize-action-symbol]');
    if (label) label.textContent = selected ? 'Edit' : 'Add';
    if (symbol) symbol.textContent = selected ? '›' : '+';
  }

  function updateFeeNote(root, key) {
    var note = root.querySelector('[data-av-customize-fee-note="' + key + '"]');
    if (!note) return;
    var option = firstBacking(root, key);
    var price = getPrice(option);
    note.innerHTML = price ? 'This option adds <span class="av-product-hero__customize-fee-price">' + price + '</span> when saved.' : '';
    note.hidden = !price;
  }

  function setNativeSelectValue(select, value) {
    if (!select) return;
    select.value = value;
    dispatchNativeChange(select);
  }

  function dispatchNativeChange(element, type) {
    if (!element) return;
    element.dispatchEvent(new Event(type || 'change', { bubbles: true }));
  }

  function addPill(container, value, swatch, color, price) {
    if (!value) return;
    var pill = document.createElement('span');
    pill.className = 'av-product-hero__customize-pill' + (price ? ' av-product-hero__customize-pill--price' : '') + (swatch ? ' av-product-hero__customize-pill--swatch' : '');
    if (swatch) pill.style.setProperty('--av-swatch', colorToCss(color));
    pill.textContent = value;
    container.appendChild(pill);
  }

  function selectedText(select) {
    return select && select.selectedOptions && select.selectedOptions[0] ? select.selectedOptions[0].textContent.trim() : (select ? select.value : '');
  }

  function colorToCss(value) {
    var map = { black: '#050505', white: '#f8fafc', red: '#ef4444', blue: '#3b82f6', green: '#22c55e', purple: '#8b5cf6', pink: '#ec4899', orange: '#f97316', yellow: '#eab308', gold: '#d4af37', silver: '#c0c0c0', gray: '#64748b', grey: '#64748b' };
    var key = String(value || '').toLowerCase().replace(/[^a-z]/g, '');
    return map[key] || value || '#c7d2fe';
  }

  function updateCount(root, key) {
    var input = root.querySelector('[data-av-customize-draft="' + key + ':value"]');
    var count = root.querySelector('[data-av-customize-count="' + key + '"]');
    if (input && count && input.maxLength > 0) count.textContent = input.value.length + '/' + input.maxLength;
  }

  function showError(root, key) { var e = root.querySelector('[data-av-customize-error="' + key + '"]'); if (e) e.hidden = false; }
  function clearError(root, key) { var e = root.querySelector('[data-av-customize-error="' + key + '"]'); if (e) e.hidden = true; }

  function rebuildOpenChoices(root) {
    var data = state.get(root);
    if (data && data.openDialog) {
      syncDraftFromBacking(root, data.openDialog.dataset.avCustomizeDialog);
      if (data.openDialog.dataset.avCustomizeDialog === 'stock_icon') syncIconRequestMode(root);
      updateDialogScrollCue(data.openDialog);
      updateDialogScrollIndicator(data.openDialog);
      requestAnimationFrame(function () {
        updateDialogScrollCue(data.openDialog);
        updateDialogScrollIndicator(data.openDialog);
      });
    }
  }

  function trapFocus(event, dialog) {
    var items = Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE)).filter(function (el) { return !el.disabled && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    var root = target && target.matches && target.matches('[id^="av-product-hero-"]')
      ? target
      : target && target.querySelector && target.querySelector('[id^="av-product-hero-"]');

    if (root) closeDialog(root, { skipFocus: true });
  });
  if (document.readyState !== 'loading') initAll();

  window.ArcaversePersonalizationHub = {
    initRoot: initRoot,
    openDialog: openDialog,
    closeDialog: closeDialog,
    syncDraftFromBacking: syncDraftFromBacking,
    saveDraftToBacking: saveDraftToBacking,
    clearBackingSelection: clearBackingSelection,
    updateAllSummaries: updateAllSummaries,
    updateRowVisibility: updateRowVisibility,
    buildChoiceButtonsFromSelect: buildChoiceButtonsFromSelect,
    buildColorEditor: buildColorEditor,
    trapFocus: trapFocus,
    setRowAction: setRowAction,
    updateFeeNote: updateFeeNote,
    setNativeSelectValue: setNativeSelectValue,
    dispatchNativeChange: dispatchNativeChange,
    setMasterEnabled: setMasterEnabled,
    scrubActiveCustomization: scrubActiveCustomization
  };
}());
